module.exports = __webpack_public_path__ + "static/juntas-cover-e6f353259859b069be662cb97e3a37cb.png";